








import { Component, Mixins } from "vue-property-decorator";
import { PropertyEditableMixin, NewObjectLocatableMixin, TextDrawerPropertyEditableMixin } from "./mixins";
import MovableTextBoxPropertyEditor from "./MovableTextBoxPropertyEditor.vue";

@Component({
  components: {
    propertyEditor: MovableTextBoxPropertyEditor,
  },
})
export default class NewTextPropertyEditor extends Mixins(PropertyEditableMixin, NewObjectLocatableMixin, TextDrawerPropertyEditableMixin) {
  async mounted(): Promise<void> {
    this.editingSource = await this.createSource();
    this.process = () => this.layoutRectangle(20, 20);
  }
}
